import script from "./purchaseReport.vue?vue&type=script&setup=true&lang=js"
export * from "./purchaseReport.vue?vue&type=script&setup=true&lang=js"

import "./purchaseReport.vue?vue&type=style&index=0&id=c30e12ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c30e12ba"]])

export default __exports__